/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export type EyeIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const EyeIcon: React.FC<EyeIconProps> = ({
  title = 'Eye',
  viewBox = '0 0 48 48',
  ...props
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M1.333 24.057c7-11.11 25.867-26.666 45.334 0-7.334 11.334-26.667 27.2-45.334 0zm32 0a9.333 9.333 0 11-18.666 0 9.333 9.333 0 0118.666 0zM24 28a4 4 0 100-8 4 4 0 000 8z"/>
  </CreateIconComponent>
);

export default EyeIcon;
